export enum SearchCriteria {
  PICKED_TIME = 'PICKUP_TIME',
  ARRIVAL_TIME = 'ARRIVAL_TIME',
}
